import React from 'react';
import { useTranslation } from 'react-i18next';
import { HowToUsePoints } from '@components/templates/marketplace';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';

export function HowToUsePointsPage() {
    const { allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('how-to-use-points-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('how-to-use-points-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        // image: #TODO
        url: SITE_URLS.howToUsePoints,
        index: true,
    });

    return <HowToUsePoints />;
}
